import { ExpiredIcon } from '../../../../assets/svg/payment-links-custom/ExpiredIcon';
import { FailedIcon } from '../../../../assets/svg/payment-links-custom/FailedIcon';
import { PendingIcon } from '../../../../assets/svg/payment-links-custom/PendingIcon';
import { SuccessIcon } from '../../../../assets/svg/payment-links-custom/SuccessIcon';
import { Status as IStatus } from '../../../../models/common-payments';
import { StatusMap as Label } from '../../../../models/payment-links-custom';
import { StatusContainer } from './styles';

interface StatusProps {
	status: IStatus;
}
export const RenderIcon = ({ status }: StatusProps) => {
	switch (status) {
		case 'success':
			return <SuccessIcon />;
		case 'pending':
			return <PendingIcon />;
		case 'expired':
			return <ExpiredIcon />;
		case 'error':
			return <FailedIcon />;
		case 'aborted':
			return <FailedIcon />;
		default:
			return null;
	}
};

const StatusCustomPaymentLink = ({ status }: StatusProps) => {
	return (
		<StatusContainer>
			<RenderIcon status={status} />
			<span>{Label.get(status) ? Label.get(status) : 'No encontrado'}</span>
		</StatusContainer>
	);
};

export { StatusCustomPaymentLink };
